import { getQuestionTypeByApiType, toLocal } from '@/utils/utils';
import { Vue, Component } from 'vue-property-decorator';
import { QUESTION_TYPES } from '@/utils/question';

/**
 * Analytic API serializer
 */
export class AnalyticSerializer extends Vue {

    private static INSTANCE = new AnalyticSerializer();

    static get instance() {
        return this.INSTANCE;
    }

    public serializeActivityPerformance(payload: any) {
        const serializer = this;
        payload = payload.content || {};
        const collection = payload.collection || payload.assessment;
        const resources = payload.resources || payload.questions;
        return {
          score: collection ? collection.score : null,
          collectionId: collection ? collection.id : null,
          timespent: collection ? collection.timespent : null,
          resourceResults: serializer.normalizeResourceResults(resources),
          reaction: collection ? collection.reaction : null,
          submittedAt:
            collection && collection.eventTime
              ? toLocal(collection.eventTime)
              : null,
          type: collection ? collection.type : null,
        };
      }

      public normalizeResourceResults(resourceResults = []) {
        const serializer = this;
        const normalizedResourceResults: any = [];

        resourceResults.map((resourceResult) => {
          normalizedResourceResults.push(
            serializer.normalizeResourceResult(resourceResult),
          );
        });
        return normalizedResourceResults;
      }

      public normalizeResourceResult(resourceResult: any) {
        const serializer = this;
        let questionType = resourceResult.questionType;
        let answerObjects;
        const resourceType = resourceResult.resourceType;
        if (resourceType === 'question') {
          if (Object.values(QUESTION_TYPES).indexOf(questionType) <= -1) {
            questionType = getQuestionTypeByApiType(questionType);
          }
          answerObjects = serializer
            .normalizeAnswerObjects(resourceResult.answerObject, questionType);
        }

        const eventTime = resourceResult.eventTime
          ? toLocal(resourceResult.eventTime)
          : null;
        const timespent = resourceResult.timespent || resourceResult.timeSpent;

        return {
          // Commons fields for real time and student collection performance
          resourceId: resourceResult.id,
          reaction: resourceResult.reaction,
          timespent,
          answerObject: resourceResult.answerObject,
          answerStatus:
            resourceResult.answerStatus ||
            (!resourceResult.score &&
            (!resourceResult.answerObject ||
            !resourceResult.answerObject.length) &&
            !timespent
              ? 'skipped'
              : 'completed'),
          userAnswer:
            resourceType === 'question'
              ? serializer.toUserAnswer(answerObjects)
              : null,
          correct: resourceResult.score > 0,
          score: resourceResult.score,
          title: resourceResult.title,
          maxScore: resourceResult.maxScore,
          resourceType,
          questionType,
          eventTime,
          isGraded: resourceResult.isGraded,
        };
      }

      public normalizeAnswerObjects(answerObjects: any, questionType: any) {
        answerObjects =
          !answerObjects || answerObjects === 'N/A' || answerObjects === 'NA'
            ? []
            : answerObjects;
        if (typeof answerObjects === 'string') {
          answerObjects = JSON.parse(answerObjects);
        }

        if (!Array.isArray(answerObjects)) {
          answerObjects = [];
        }
        return answerObjects.map((answerObject: any) => {
          if (questionType !== 'MA' && answerObject.text) {
            answerObject.answerId = window.btoa(
              encodeURIComponent(answerObject.text),
            );
          }
          return answerObject;
        });
      }

      public toUserAnswer(answerObjects: any) {
        return !answerObjects || !answerObjects.length
          ? null // if not respond is provided
          : answerObjects.map((answerObject: any) => {
            return {
              id: answerObject.answerId,
              selection: answerObject.text === 'Yes',
            };
          });
      }
}

export const analyticSerializer = AnalyticSerializer.instance;
